module.exports = __webpack_public_path__ + "img/gallery-15.76137feb.jpg";